module.exports = __webpack_public_path__ + "static/img/ilustra_verso_outro_doc.3f9009f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dicas-doc/ilustra_verso_outro_doc.png
// module id = S09I
// module chunks = 2